<template>
  <div class="quantity" :class="{ 'quantity--shadow': shadow, 'quantity--border': border }">
    <button type="button" @click="decrement" class="quantity__button" :disabled="value <= 1">
      <i class="fal fa-minus"></i>
    </button>
    <input type="tel" v-model.number="value" @input="emitNewValue" @blur="checkForNumber"/>
    <button type="button" @click="increment" class="quantity__button">
      <i class="fal fa-plus"></i>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      required: true
    },
    shadow: {
      type: Boolean,
      default: true
    },
    border: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    increment() {
      this.$emit("input", this.value + 1);
    },
    decrement() {
      if (this.value <= 1) return;
      this.$emit("input", this.value - 1);
    },
    emitNewValue() {
      this.$emit("input", this.value);
    },
    checkForNumber() {
      if (isNaN(this.value) || !this.value) {
        this.value = 1;
      }
      this.$emit("input", this.value);
    }
  }
};
</script>

<style lang="scss" scoped>
.quantity {
  display: inline-block;
  background-color: $white;
  border-radius: 4px;
  padding: 16px;
  font-family: $font-family;
  border: none;
  display: flex;
  align-items: center;
  font-size: 21px;

  &--shadow {
    box-shadow: 0 1px 2px 0 rgba(51, 66, 66, 0.09);
  }

  &--border {
    box-shadow: none;
    border: 2px solid $border;
  }

  &__quantity {
    padding: 0 8px;
    width: 40px;
    text-align: center;
  }

  &__button {
    appearance: none;
    border: none;
    font-size: 18px;
    background-color: transparent;
  }
  input {
    appearance: none;
    padding: 0 8px;
    width: 40px;
    text-align: center;
    font-family: $font-family;
    font-size: 21px;
    border: none;
  }
}
</style>
